import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEyeSlash } from '@fortawesome/pro-light-svg-icons'

import { Box, Image, StatusBadge } from '@domain-group/suit-theme'

import useImage from '@hooks/useImage'

import { ImageModel } from '@models/types'

type GetBackgroundColorParams = {
  fadePrivate?: boolean,
  isPrivate: boolean,
  isSelected: boolean,
}

const getBackgroundColor = (params: GetBackgroundColorParams) => {
  const { fadePrivate, isPrivate, isSelected } = params

  if (isSelected) return 'rgba(0, 0, 0, 0.5)'
  if (isPrivate && fadePrivate) return 'rgba(255, 255, 255, 0.7)'
  return null
}

interface ImageTileProps {
  bulkSelecting: boolean,
  callbacks: {
    toggleId: (imageId: number) => void,
    selectImage: (id: number) => void,
  },
  fadePrivate?: boolean,
  hasExportSizeError: boolean,
  image: ImageModel,
  selectionIndex: number,
  square?: boolean,
}

const ImageTile = (props: ImageTileProps) => {
  const {
    bulkSelecting, callbacks, fadePrivate, hasExportSizeError, image, selectionIndex, square,
  } = props

  const { toggleId, selectImage } = callbacks

  const isSelected = selectionIndex >= 0

  const imagePayload = useImage(image)
  const {
    image: {
      id, id_code, private: isPrivate, original_url, thumb_url,
    },
    isPlan,
    resolution: { label, warn },
  } = imagePayload

  const imageUrl = isPlan ? original_url : thumb_url

  return (
    <Image
      borderRadius={5}
      boxProps={{
        backgroundSize: isPlan ? 'contain' : 'cover',
        border: '1px solid #ececec',
        onClick: bulkSelecting ? () => toggleId(id) : () => selectImage(id),
      }}
      height={square ? undefined : 140}
      style={square ? { aspectRatio: '1 / 1' } : undefined}
      url={imageUrl}
      width="100%"
    >
      <Box
        alignItems="center"
        // @ts-expect-error TS2322
        backgroundColor={getBackgroundColor({ fadePrivate, isPrivate, isSelected })}
        borderRadius={5}
        height="100%"
        justifyContent="center"
        position="relative"
        style={{ cursor: 'pointer' }}
      >
        {hasExportSizeError && (
          <StatusBadge
            boxProps={{
              position: 'absolute',
              top: 'medium',
              left: 'medium',
              width: 'auto',
            }}
            color="red"
            text="Error"
          />
        )}

        {!hasExportSizeError && warn && (
          <StatusBadge
            boxProps={{
              position: 'absolute',
              top: 'medium',
              left: 'medium',
              width: 'auto',
            }}
            color={label === 'Low' ? 'red' : 'orange'}
            text={label}
          />
        )}

        {id_code && (
          <StatusBadge
            boxProps={{
              position: 'absolute',
              top: 'medium',
              right: 'medium',
              width: 'auto',
            }}
            color="rgba(0, 0, 0, 0.8)"
            text={id_code}
          />
        )}

        {isPrivate && (
          <StatusBadge
            boxProps={{
              padding: 'small',
              position: 'absolute',
              left: 'medium',
              bottom: 'medium',
              width: 'auto',
            }}
            color="grey"
            icon={<FontAwesomeIcon icon={faEyeSlash} />}
          />
        )}

        {isSelected && (
          <Box
            alignItems="center"
            backgroundColor="rgba(0, 0, 0, 0.5)"
            border="2px solid white"
            borderRadius="100%"
            color="white"
            height="40px"
            justifyContent="center"
            width="40px"
          >
            {selectionIndex + 1}
          </Box>
        )}
      </Box>
    </Image>
  )
}

export default ImageTile
